export default __webpack_public_path__ + "static/card-blue-598a6cb5eae21951c99e93c43418f2e1.png";